import { render, staticRenderFns } from "./OpdCreate.vue?vue&type=template&id=5deee8c4"
import script from "./OpdCreate.vue?vue&type=script&lang=js"
export * from "./OpdCreate.vue?vue&type=script&lang=js"
import style0 from "./OpdCreate.vue?vue&type=style&index=0&id=5deee8c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports